export enum ELD_MODES {
  LOGS = 'logs',
  EXEMPTED = 'exempt',
  None = 'none',
}
